"use client";
import { Button } from "@/components/ui/button";
import { useNomineesCtx } from "./contexts/nomination";
import { SubCategorySelector } from "./subCategory-selector";
import { CategoryDropdown } from "./category-dropdown";
import { useLocaleCtx } from "@/contexts/locale";
import { useTranslation } from "@/i18n/client";
import GradientBorder from "../common/gradient-border";

export default function TopBar() {
  const { category, subCategory, setCategory, setSubCategory, categories } = useNomineesCtx();
  const { lang } = useLocaleCtx();
  const { t } = useTranslation(lang, "nominees");
  return (
    <>
      <div className="relative w-full">
        <h1 className="mb-10 text-center text-3xl text-secondary sm:text-4xl lg:text-left ltr:font-playfair rtl:text-right">
          {t("2025")}
        </h1>
        <div className="flex flex-col items-center md:flex-row md:justify-between md:gap-10">
          <div className="relative hidden w-screen overflow-hidden bg-foreground px-6 py-2 backdrop-blur-md sm:w-fit sm:justify-center sm:gap-4 sm:rounded-full sm:px-10 sm:py-2 lg:flex lg:max-w-[673px] lg:py-4 2xl:max-w-fit">
            <GradientBorder />
            {categories?.map((cat) => {
              const isActive = cat.title === category.title;

              return (
                <div key={cat.title} className="relative">
                  {isActive && (
                    <div className="absolute inset-x-0 -bottom-2 z-10 h-[1px] bg-white sm:-bottom-2 lg:-bottom-4" />
                  )}
                  <Button
                    variant="ghost"
                    onClick={() =>
                      setCategory({
                        title: cat.title,
                        value: cat.value,
                      })
                    }
                    className={`relative z-20 rounded-none text-xs font-normal text-[#FFCC68] 2xl:text-base ltr:font-opensans ${isActive ? "" : "opacity-40"}`}
                  >
                    {cat.title}
                  </Button>
                </div>
              );
            })}
          </div>
          <div className="mx-auto flex flex-col items-start gap-4 md:flex-row md:items-center md:gap-8 lg:mx-0">
            <div className="flex items-center gap-2 lg:hidden ltr:font-opensans">
              <span className="w-16 text-sm text-secondary opacity-40 md:w-auto">
                {t("Category")}:
              </span>
              <CategoryDropdown categories={categories} setCategory={setCategory} />
            </div>
            <div className="flex items-center gap-2 ltr:font-opensans">
              <span className="w-16 text-sm text-secondary opacity-40 md:w-auto">
                {t("Award")}:
              </span>
              <SubCategorySelector
                category={category}
                categories={categories}
                setSubCategory={setSubCategory}
                subCategory={subCategory}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
